<template>
  <div style="display:flex;">
    <div v-for="(category_jpn, category_eng) in work_categories" :key="category_eng">
        <Exclamation-Triangle
            v-if="Object.values(alert_per_workcategory).filter(val => val.workpattern_category === category_eng).length > 0"
            active_dialog="work_category"
            :alert_per_workcategory="alert_per_workcategory"
            :officeId="officeId"
            :teamId="teamId"
            :year="year"
            :month="month"
            :width="'50'"
        />

        <div v-else="Object.values(alert_per_workcategory).filter(val => val.workpattern_category === category_eng).length > 0" style="margin-left:50px;">
        <!-- 調整のための空DIV -->
        </div>
    </div>
  </div>
</template>

<script>
import ExclamationTriangle from '@/Pages/Components/Svg/ExclamationTriangle.vue'
export default {
    name: 'AlertWorkCategory',
    components: {
        ExclamationTriangle
    },
    props: {
        workpatterns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        basic_infos_filtered: {
            type: Array,
            default: () => {
                return [];
            }
        },
        shift_data: {
            type: Object,
            default: function() {
                return {};
            }
        },
        office_staff_workpatterns: {
            type: Array,
            default: () => {
                return [];
            }
        },
        all_staffs: {
            type: Object,
            default: function() {
                return {};
            }
        },
        staff_assignments: {
            type: Object,
            default: function() {
                return {};
            }
        },
        days_count_per_weekday: {
            type: Object,
            default: function() {
                return {};
            }
        },
        no_condition_staffs: {
            type: Object,
            default: function() {
                return {};
            }
        },
        work_categories: {
            type: Object,
            default: function() {
                return {};
            }
        },
        officeId: {
          type: Number
        },
        teamId: {
          type: Number
        },
        year: {
          type: String
        },
        month: {
          type: String
        },
    },
    data() {
        return {
            max_staff_allocation_per_workpattern_id: {}, //ワークパターンidごとの配置人数上限
            max_staff_allocation_per_workpattern_category: {}, //ワークパターンカテゴリごとの配置人数上限
            max_work_count_staff_status: {}, //総数、退職、離職ごとの勤務回数上限
            shift_all_holiday_each_office_staff: {}, //全て休暇に設定されているスタッフID
            alert_per_workcategory: {} //エラーが起きている箇所
        }
    },
    mounted(){
    },
    created(){
        this.$nextTick(() => {
            this.calcAlert()
        })
    },
    methods: {
        //判定に必要な値を計算する
        initial(){
            this.shiftAllHolidayEachOfficeStaff()
            this.getMaxStaffAllocationEachWorkpatternCategory()
            this.getMaxWorkCountEachStaffStatus()
        },
        /*
        * alert条件 カテゴリごとに下の条件を満たした場合
        * (常時配置人数の上限) × (月の日数) < 
        * (〇になってる勤務回数上限の総合計) - (休職フラグがONの職員の勤務回数上限) - (退職フラグがONの職員の勤務回数上限) - (シフト表ですべての日付に休暇（公休、有休、その他含む）が配置されている職員の勤務回数上限)
         */
        calcAlert(){
            this.initial()
            
            //初期化
            this.alert_per_workcategory = {}

            Object.entries(this.max_staff_allocation_per_workpattern_id).forEach(([workpattern_id, allocation_value]) => {
                let max_work_count_total = this.max_work_count_staff_status.total[workpattern_id]
                let max_work_count_suspention = this.max_work_count_staff_status.suspention[workpattern_id]
                let max_work_count_retirement = this.max_work_count_staff_status.retirement[workpattern_id]
                let all_holiday_staff_work_count = this.max_work_count_staff_status.all_holiday_staff[workpattern_id]
                let is_alert = allocation_value.count > max_work_count_total - max_work_count_retirement - max_work_count_suspention - all_holiday_staff_work_count
                let shortage_cnt = allocation_value.count - (max_work_count_total - max_work_count_retirement - max_work_count_suspention - all_holiday_staff_work_count)

                if(is_alert) {
                    let set_value = {
                        workpattern_category_jpn_short_name: allocation_value.workpattern_category_jpn_short_name,
                        workpattern_category: allocation_value.workpattern_category,
                        shortage_cnt: shortage_cnt
                    }
                    this.$set(this.alert_per_workcategory, workpattern_id, set_value);
                }
            })
        },
        //ワークパターンカテゴリごとの配置人数上限の計算
        getMaxStaffAllocationEachWorkpatternCategory() {
            this.office_staff_workpatterns.forEach(staff_workpattern => {
                let assignments = {}

                if(this.staff_assignments[staff_workpattern.workpattern_id]){
                    assignments = this.staff_assignments[staff_workpattern.workpattern_id]

                    if (!assignments) return

                    this.max_staff_allocation_per_workpattern_id[staff_workpattern.workpattern_id] = {
                        count: 0,
                        workpattern_category_jpn_short_name: staff_workpattern.name,
                        workpattern_category: staff_workpattern.category
                    }

                    Object.entries(assignments).forEach(([short_weekday_name, assignment]) => {
                        //defは処理しない
                        if(short_weekday_name === 'def') return
                        
                        let days_count_per_weekday = this.days_count_per_weekday[short_weekday_name]
                        let max_assignment = parseInt(assignment.max) === 0
                            ? assignments.def.max 
                            : assignment.max;

                        this.max_staff_allocation_per_workpattern_id[staff_workpattern.workpattern_id].count += max_assignment * days_count_per_weekday
                    })
                }
            })
        },
        //総数、休職、退職スタッフの勤務回数上限の集計
        getMaxWorkCountEachStaffStatus() {
            let total_max_count = {}
            let suspension_max_count = {}
            let retirement_max_count = {}
            let all_holiday_staff_max_count = {}

            this.office_staff_workpatterns.forEach(staff_workpattern => {
                //総数、休職、退職の集計初期化
                total_max_count[staff_workpattern.id] = total_max_count[staff_workpattern.id] || 0
                suspension_max_count[staff_workpattern.id] = suspension_max_count[staff_workpattern.id] || 0
                retirement_max_count[staff_workpattern.id] = retirement_max_count[staff_workpattern.id] || 0
                all_holiday_staff_max_count[staff_workpattern.id] = all_holiday_staff_max_count[staff_workpattern.id] || 0

                total_max_count[staff_workpattern.id] += staff_workpattern.max_monthly_working_count

                if(this.shift_all_holiday_each_office_staff && this.shift_all_holiday_each_office_staff[staff_workpattern.office_staff_id]){
                    all_holiday_staff_max_count[staff_workpattern.id] += staff_workpattern.max_monthly_working_count
                }

                Object.entries(this.all_staffs).forEach(([key, staff]) => {
                    if(staff_workpattern.office_staff_id == staff.id && staff.suspension_flg){
                        suspension_max_count[staff_workpattern.id] += staff_workpattern.max_monthly_working_count
                    }
                    if(staff_workpattern.office_staff_id == staff.id && staff.retirement_date){
                        retirement_max_count[staff_workpattern.id] += staff_workpattern.max_monthly_working_count
                    }
                });
            });

            this.max_work_count_staff_status = {
                total:  total_max_count,
                suspention: suspension_max_count,
                retirement: retirement_max_count,
                all_holiday_staff: all_holiday_staff_max_count
            }
        },
        //シフトが全て休日で埋まっているスタッフかどうか
        shiftAllHolidayEachOfficeStaff(){
            //全てのシフトが休日になっているかどうか(office_staff_idごと)
            let shift_all_holiday_each_office_staff = {}
            Object.entries(this.basic_infos_filtered).forEach(([key, basic_info]) => {
                let office_staff_id_occupation_id = basic_info.office_staff_id + "_" + basic_info.occupation_id
                //初期化
                if (!shift_all_holiday_each_office_staff.hasOwnProperty(basic_info.office_staff_id)) {
                    shift_all_holiday_each_office_staff[basic_info.office_staff_id] = true
                }
                if(this.shift_data[office_staff_id_occupation_id]) {
                    Object.entries(this.shift_data[office_staff_id_occupation_id]).forEach(([date, shift]) => {
                        let category = shift?.shift?.workpattern?.category
                        //shiftが無かった時、categoryがholidayじゃない時、categoryがnullだった時(workpatternを消した場合)
                        if (
                            !('shift' in shift) ||
                            (category && category !== 'holiday') ||
                            !category
                        ) {
                            shift_all_holiday_each_office_staff[basic_info.office_staff_id] = false
                            return
                        }
                    })
                }
            })
            
            this.shift_all_holiday_each_office_staff = shift_all_holiday_each_office_staff
        }
    },
    watch: {
        staff_assignments: {
            handler() {
                this.calcAlert();
            },
            deep: true,
        },
        office_staff_workpatterns: {
            handler() {
                this.calcAlert();
            },
            deep: true,
        },
        shift_data: {
            handler() {
                this.calcAlert();
            },
            deep: true, 
        }
    }
}
</script>
